import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, NavLink } from 'react-router-dom';
import './App.css';
import MenuPage from './pages/MenuPage';
import ShoppingPage from './pages/ShoppingPage';
import StockPage from './pages/StockPage';
import PreferencesPage from './pages/PreferencesPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import Header from './components/Header';
import AdBanner from './components/AdBanner';
import Footer from './components/Footer';
import LoginPage from './pages/LoginPage';
import { API_URL } from './config/api';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [userId, setUserId] = useState(localStorage.getItem('userId') || '');
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);

  const logout = useCallback(() => {
    setToken('');
    setUserId('');
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
  }, []);

  const verifyToken = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setUser(data.user);
      } else {
        logout();
      }
    } catch (err) {
      console.error(err);
      logout();
    }
    setLoading(false);
  }, [token, logout]);

  useEffect(() => {
    if (token && userId) {
      verifyToken();
    }
  }, [token, userId, verifyToken]);

  const login = (newToken, newUserId) => {
    setToken(newToken);
    setUserId(newUserId);
    localStorage.setItem('token', newToken);
    localStorage.setItem('userId', newUserId);
  };

  if (loading) {
    return <div className="app loading"><p>Cocinando... el inicio puede demorar hasta 20 segundos.</p></div>;
  }

  const isAuthenticated = Boolean(token && user);

  return (
    <Router>
      <div className="app">
        {isAuthenticated ? <Header user={user} onLogout={logout} /> : null}
        {isAuthenticated ? <AdBanner /> : null}
        {isAuthenticated ? (
          <nav className="bottom-nav">
            <NavLink to="/" className={({ isActive }) => (isActive ? 'active' : '')}>Menú</NavLink>
            <NavLink to="/stock" className={({ isActive }) => (isActive ? 'active' : '')}>Stock</NavLink>
            <NavLink to="/compras" className={({ isActive }) => (isActive ? 'active' : '')}>Compras</NavLink>
            <NavLink to="/preferencias" className={({ isActive }) => (isActive ? 'active' : '')}>Preferencias</NavLink>
          </nav>
        ) : null}
        <Routes>
          <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <LoginPage onLogin={login} />} />
          <Route path="/terminos" element={<TermsPage />} />
          <Route path="/privacidad" element={<PrivacyPage />} />
          <Route path="/" element={isAuthenticated ? <MenuPage userId={userId} token={token} /> : <Navigate to="/login" />} />
          <Route path="/stock" element={isAuthenticated ? <StockPage userId={userId} token={token} /> : <Navigate to="/login" />} />
          <Route path="/compras" element={isAuthenticated ? <ShoppingPage userId={userId} token={token} /> : <Navigate to="/login" />} />
          <Route path="/preferencias" element={isAuthenticated ? <PreferencesPage userId={userId} token={token} /> : <Navigate to="/login" />} />
          <Route path="*" element={<Navigate to={isAuthenticated ? '/' : '/login'} />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
